import { useMemo, useRef } from 'react'

/**
 * Formül girdisi — gerçek `<input>` + arkasında boyalı ayna katmanı.
 *
 * Bot modalındaki parametre kutuları ve `Değerlendir` test aracı ortak
 * kullanıyor. Girdinin kendi yazısı saydam, imleci görünür; boyama arkadaki
 * katmanda. İki katman aynı yazı tipini/dolguyu paylaşmak ZORUNDA, yoksa
 * imleç ile harfler kayar. Uzun formülde yatay kaydırma `onScroll` ile
 * aynalanıyor.
 */

/** Sözdizimi boyama: sayı kehribar, `Math.*` mavi, DSL değişkeni mor, operatör soluk. */
function boya(kod: string) {
  const parcalar = kod.match(/[A-Za-z_][\w.]*|\d+(?:\.\d+)?|\s+|./g) ?? []
  return parcalar.map((t, i) => {
    if (/^\s+$/.test(t)) return t
    const cls = /^\d/.test(t)
      ? 'tok-num'
      : t === 'true' || t === 'false'
        ? 'tok-bool'
        : t.startsWith('Math.')
          ? 'tok-fn'
          : /^[A-Z]/.test(t)
            ? 'tok-var'
            : 'tok-op'
    return (
      <span key={i} className={cls}>
        {t}
      </span>
    )
  })
}

export function FormulInput({
  value,
  onChange,
  locked = false,
  lockNote,
  onEnter,
}: {
  value: string
  onChange: (v: string) => void
  /** Şablon gereği sabit 0 — kutu değiştirilemez, kilit ikonu görünür. */
  locked?: boolean
  lockNote?: string
  /** Enter'a basılınca (test aracında "değerlendir" kısayolu). */
  onEnter?: () => void
}) {
  const ayna = useRef<HTMLDivElement>(null)
  const gosterilen = locked ? '0' : value
  const boyali = useMemo(() => boya(gosterilen), [gosterilen])
  return (
    <div className={`bot-formula${locked ? ' locked' : ''}`}>
      <div className="bot-formula-view" ref={ayna} aria-hidden="true">
        {boyali}
      </div>
      <input
        className="bot-formula-input"
        type="text"
        spellCheck={false}
        autoComplete="off"
        value={gosterilen}
        placeholder="sayı ya da sayı döndüren formül"
        disabled={locked}
        aria-label={locked ? lockNote : undefined}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onEnter?.()
        }}
        onScroll={(e) => {
          if (ayna.current) ayna.current.scrollLeft = e.currentTarget.scrollLeft
        }}
      />
      {locked && (
        <span className="bot-lock" title={lockNote}>
          <svg viewBox="0 0 12 12" width="11" height="11" aria-hidden="true">
            <rect x="2.2" y="5.3" width="7.6" height="5.2" rx="1.2" />
            <path d="M3.9 5.3V3.9a2.1 2.1 0 0 1 4.2 0v1.4" fill="none" />
          </svg>
        </span>
      )}
    </div>
  )
}
